import { ReactNode } from 'react';

type Props = {
  children: ReactNode
}

export function Variant({ children }: Props) {
  return children;
}
